<template>
  <table class="table">
    <thead>
        <th v-for="column in columns">{{column}}</th>
    </thead>
    <tbody>
        <slot name="table-row"></slot>
    </tbody>
  </table>
</template>
<script>
  export default {
    name: 'l-table',
    props: {
      columns: Array,
      data: Array,
        rowClassCondition: {}
    },
    methods: {
        addClass(item){
            console.log("item : ", item);
        }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Table.vue